/*
 * Footer Messages
 *
 * This contains all the text for the Footer component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  analiseErrorLoading: {
    id: 'analise.error.loading',
    defaultMessage: 'Hmm er is iets fout gegaan...'
  },
  analiseOverviewTitle: {
    id: 'analise.overview.title',
    defaultMessage: 'analyse overview titel'
  },
  analiseIntroText: {
    id: 'analise.overview.intro',
    defaultMessage: `<ol>
        <li>Laad je video op <em>(klik op refresh van je browser wanneer het opladen niet lukt)</em></li>
        <li>Selecteer je video</li>
        <li>Klik op ”Analyseer”</li>
    </ol>`
  },
  analiseNoAnalyses: {
    id: 'select.Title',
    defaultMessage: 'Geen analyses gevonden ...'
  },
  analiseOverviewUploadDate: {
    id: 'analise.overview.uploadDate',
    defaultMessage: 'Geüpload op '
  },
  analiseOverviewSliderNext: {
    id: 'analise.overview.slider.next',
    defaultMessage: 'VOLGENDE'
  },
  analiseOverviewSliderPrevious: {
    id: 'analise.overview.slider.previous',
    defaultMessage: 'VORIGE'
  },
  analiseOverviewAnalyseTitle: {
    id: 'analise.overview.analyseTitle',
    defaultMessage: 'Analyses'
  },
  analiseOverviewButton: {
    id: 'analise.overview.Button',
    defaultMessage: 'Analyseer'
  },
  analyseShareButton: {
    id: 'analise.share.Button',
    defaultMessage: 'Delen'
  },
  analyseSharedTitle: {
    id: 'analise.shared.Title',
    defaultMessage: 'Gedeeld met ...'
  },
  analyseSharedLabel: {
    id: 'analise.shared.Label',
    defaultMessage: 'Gedeeld met mij'
  },
  analyseSharedNoResult: {
    id: 'analise.shared.no_results',
    defaultMessage: 'De analyse werd nog niet gedeeld'
  },
  analyseOverviewModalProgressTitle: {
    id: 'analyse.overview.modal.progress.title',
    defaultMessage: 'Video nog niet klaar'
  },
  analyseOverviewModalProgressDescription: {
    id: 'analyse.overview.modal.progress.description',
    defaultMessage:
      'Uw video is nog niet klaar voor gebruik. Nog even geduld...'
  },
  analyseOverviewModalProgressButton: {
    id: 'analyse.overview.modal.progress.button',
    defaultMessage: 'OK'
  },
  analyseOverviewModalInfoTitle: {
    id: 'analyse.overview.modal.info.title',
    defaultMessage: 'Uploaden en transcoden'
  },
  analyseOverviewModalInfoDescription: {
    id: 'analyse.overview.modal.info.description',
    defaultMessage:
      'Video is aan het uploaden en transcoden, afhankelijk van de grootte van de video kan dit langer duren.<br><br>Na de voorbereidingen komt deze in uw overzicht te zien. De opgeladen videos zijn enkel zichtbaar voor u.'
  },
  analyseOverviewModalInfoButton: {
    id: 'analyse.overview.modal.info.button',
    defaultMessage: 'OK'
  },
  analyseOverviewModalDeleteAnalyseTitle: {
    id: 'analyse.overview.modal.delete.analyse.title',
    defaultMessage: 'Analyse verwijderen'
  },
  analyseOverviewModalDeleteAnalyseDescription: {
    id: 'analyse.overview.modal.delete.analyse.description',
    defaultMessage: 'Bent u zeker dat u deze analyse wilt verwijderen?'
  },
  analyseOverviewModalDeleteAnalyseButtonOK: {
    id: 'analyse.overview.modal.delete.analyse.button.ok',
    defaultMessage: 'Verwijder'
  },
  analyseOverviewModalDeleteAnalyseButtonCancel: {
    id: 'analyse.overview.modal.delete.analyse.button.cancel',
    defaultMessage: 'Annuleer'
  },
  analyseOverviewModalDeleteVideoTitle: {
    id: 'analyse.overview.modal.delete.video.title',
    defaultMessage: 'Video verwijderen'
  },
  analyseOverviewModalDeleteVideoDescription: {
    id: 'analyse.overview.modal.delete.video.description',
    defaultMessage: 'Bent u zeker dat u deze video wilt verwijderen?'
  },
  analyseOverviewModalDeleteVideoButtonOK: {
    id: 'analyse.overview.modal.delete.video.button.ok',
    defaultMessage: 'Verwijder'
  },
  analyseOverviewModalDeleteVideoButtonCancel: {
    id: 'analyse.overview.modal.delete.video.button.cancel',
    defaultMessage: 'Annuleer'
  },
  analyseOverviewVideoUploadProgress: {
    id: 'analyse.overview.video.upload.progress',
    defaultMessage: '{progress} video(s) aan het uploaden...'
  },
  analyseOverviewVideoUploadDefault: {
    id: 'analyse.overview.video.upload.default',
    defaultMessage: 'Klik hier of sleep video(s) naar hier om te uploaden'
  },
  analyseOverviewVideoUploadReject: {
    id: 'analyse.overview.video.upload.reject',
    defaultMessage: 'Geen correcte video(s) om te uploaden'
  },
  analyseOverviewVideoUploadActive: {
    id: 'analyse.overview.video.upload.active',
    defaultMessage: 'Laat los om te uploaden'
  },
  analyseOverviewVideoModalDeleteOK: {
    id: 'analise.overview.video.modal.delete.ok',
    defaultMessage: 'OK'
  },
  analyseOverviewVideoModalDeleteCancel: {
    id: 'analise.overview.video.modal.delete.cancel',
    defaultMessage: 'Annuleer'
  },
  analiseSelectTitle: {
    id: 'analise.select.title',
    defaultMessage: 'welke bouwstenen wil je analyseren (max2)'
  },
  analiseSelectIntro: {
    id: 'analise.select.intro',
    defaultMessage:
      'Kies op basis van jouw gepersonaliseerd profiel uit \'stap 1\' een bouwsteen om te analyseren.'
  },
  analiseSelectButton: {
    id: 'analise.select.button',
    defaultMessage: 'Start Analyse'
  },
  analyseVideoTitle: {
    id: 'analise.video.title',
    defaultMessage: 'Analyseer je video'
  },
  analyseVideoIntro: {
    id: 'analise.video.intro',
    defaultMessage: ``
  },
  analiseVideoAnnotateButtonAdd: {
    id: 'analise.video.annotate.button.add',
    defaultMessage: 'Voeg annotatie toe'
  },
  analiseVideoAnnotateButtonUpdate: {
    id: 'analise.video.annotate.button.update',
    defaultMessage: 'Pas annotatie aan'
  },
  analiseVideoStartSurveyText: {
    id: 'analise.video.start.survey.text',
    defaultMessage: `Ik zou eerst ergens duidelijk maken dat het de bedoeling is dat je eerst het volledige filmpje bekijkt en annoteert. Dat je kan annoteren door te typen in vak onder filmpje.
    Nadat je het volledige filmpje geannoteerd hebt, is de volgende stap om de vragenlijst in te vullen op basis van de eigen annotaties van de volledige les, en een persoonlijk actieplan te maken.`
  },
  analiseVideoStartSurveyButton: {
    id: 'analise.video.start.survey.button',
    defaultMessage: 'Start survey'
  },
  analiseVideoNextSurveyButton: {
    id: 'analise.video.next.survey.Button',
    defaultMessage: 'Volgende'
  },
  analiseVideoReadyButton: {
    id: 'analise.video.ready.button',
    defaultMessage: 'Klaar'
  },
  analiseVideoTipsAndTricksButton: {
    id: 'analise.video.tips.and.tricks.button',
    defaultMessage: 'Tips & tricks'
  },
  analyseVideoModalDeleteTitle: {
    id: 'analise.video.modal.delete.title',
    defaultMessage: 'Opgelet'
  },
  analyseVideoModalDeleteMessage: {
    id: 'analise.video.modal.delete.message',
    defaultMessage: 'Ben je het zeker?'
  },
  analyseVideoModalDeleteOK: {
    id: 'analise.video.modal.delete.OK',
    defaultMessage: 'Verwijderen'
  },
  analyseVideoModalDeleteCancel: {
    id: 'analise.video.modal.delete.cancel',
    defaultMessage: 'Annuleer'
  },
  analyseDeleteButton: {
    id: 'analise.delete.button',
    defaultMessage: 'Verwijderen'
  },
  analyseSelectBackButton: {
    id: 'analise.info.back.button',
    defaultMessage: 'Terug naar analyseer'
  },
  analyseInfoBackButton: {
    id: 'analise.info.back.button',
    defaultMessage: 'Terug naar bouwstenen'
  },
  analyseBackButton: {
    id: 'analise.back.button',
    defaultMessage: 'Terug naar uitleg'
  },
  analyseDetailButton: {
    id: 'analise.detail.button',
    defaultMessage: 'Bekijk'
  },
  analyseInfoButton: {
    id: 'analise.info.button',
    defaultMessage: 'Analyseer'
  },
  analyseInfoVideo1: {
    id: 'analyse.info.video.1',
    defaultMessage: 'lR4ip4hX2Oo'
  },
  analyseInfoVideo2: {
    id: 'analyse.info.video.2',
    defaultMessage: '1N4U3ara32U'
  },
  analyseInfoVideo3: {
    id: 'analyse.info.video.3',
    defaultMessage: '-1ZvQseEQKc'
  },
  analyseInfoVideo4: {
    id: 'analyse.info.video.4',
    defaultMessage: 'EsFdxF3j0aY'
  },
  analyseInfoVideo5: {
    id: 'analyse.info.video.5',
    defaultMessage: '38cjsaYaaFU'
  },
  analyseInfoVideo6: {
    id: 'analyse.info.video.6',
    defaultMessage: 'xIhLUeTHR5I'
  },
  analyseInfoVideo7: {
    id: 'analyse.info.video.7',
    defaultMessage: 'ZRyzfxnd8FE'
  },
  analyseInfoVideo8: {
    id: 'analyse.info.video.8',
    defaultMessage: 'yV0CI_S3Ec4'
  },
  analyseInfoVideo9: {
    id: 'analyse.info.video.9',
    defaultMessage: 'uD-ZrUm794s'
  },
  analyseInfoBlock1: {
    id: 'analise.info.block1',
    defaultMessage: `<div class="info-block">
      <p>Als leerkracht geef je voortdurend feedback aan je sporters om hun ontwikkelingsproces te begeleiden.</p>
      <ol>
        <li>
          <h4 class="list-title">Positieve feedback</h4>
          <p class="flex flex-align-center flex-justify-space-around"><img class="full" src="/assets/images/graphs/motiverendefeedback.png"></p>
          <p class="lead-text">
            Hoe vaak geef je positieve feedback tijdens de les? Het geven van positieve feedback vormt een krachtig middel om leerlingen te motiveren. We geven meestal minder positieve feedback dan we zelf denken.
          </p>
          <p class="lead-text">
            Is de positieve feedback die je geeft meestal gericht op de uitvoering van de taak?
          </p>
          <p class="lead-text">
            Verwoord je vooral de vooruitgang die de leerlingen gemaakt hebben gedurende de tijd?
          </p>
          <p class="lead-text">
            Is de positieve feedback voldoende <strong>concreet</strong> (meer dan “goed zo”)?
          </p>
          <ul>
            <li>
            Je kan proberen <strong>procesgerichte</strong> in plaats van persoonsgerichte feedback te geven.
              <ul class="plus-minus-list">
                <li class="plus">
                  procesgericht: gericht op de uitvoering van de taken. Je maakt meer gebruik van het werkwoord "hebben" <span class="green">(‘Je hebt goed in positie gespeeld deze wedstrijd’)</span>.
                </li>
                <li class="minus">
                  persoonsgericht: geeft een waardeoordeel over de sporter als persoon <span class="red">(‘Wat een topper ben jij.’)</span> en levert weinig informatie op die de sporter vooruit kan helpen. Je maakt gebruik van het werkwoord "zijn" <span class="red">(‘Je bent een kei in het spelen van de volley’)</span>.
                </li>
              </ul>
            </li>
            <li>
            Je kan proberen <strong>intrapersoonlijke</strong> in plaats van interpersoonlijke feedback te geven.
              <ul class="plus-minus-list">
                <li class="plus">
                  intrapersoonlijk: focust op de vooruitgang die de leerling gedurende de tijd geboekt heeft <span class="green">(‘Je hebt de bocht in vergelijking met daarnet goed aangesneden’)</span>.
                </li>
                <li class="minus">
                  interpersoonlijk: focust op de prestaties in vergelijking met leeftijdsgenoten of normtabellen <span class="red">(‘Je reed in de sprint harder dan je leeftijdsgenoten!’)</span>.
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
            <h4 class="list-title">Correctieve feedback</h4>
            <p>
              Je reikt tips, strategieën en suggesties aan voor wat beter kan, zodat de leerlingen zich verder kunnen ontwikkelen.
            </p>

            <p class="lead-text">
              Geef je vaak correctieve feedback tijdens de les?
            </p>
            <p class="lead-text">
              Geef je hierbij concrete informatie over wat er juist beter kan?
            </p>

            <ul>
              <li>
                Je kan proberen om correctieve feedback op een <strong>informerende en taakgerichte</strong>, eerder dan op een <strong>evaluerende en veroordelende wijze</strong> te doen. Leraar Guido geeft feedback aan Margo over haar zojuist uitgevoerde handenstand. <span class="green">‘Je benen waren nu veel beter gestrekt dan de vorige keer. Je kunt ook eens proberen je hele lichaam te strekken en dus ook de hoek uit je heupen weg te halen. Je kunt dat doen door je benen, billen en buik aan te spannen en zo een plank van jezelf te maken.’</span>
              </li>
            </ul>
        </li>
      </ol>
      
      </div>`
  },
  analyseInfoBlock2: {
    id: 'analise.info.block2',
    defaultMessage: `<div class="info-block">
      <p>
        Je hoeft als leerkracht niet noodzakelijkerwijs alle werkpunten zelf te identificeren en daarbij behorende doelen te bepalen. Leerlingen zijn dikwijls in staat om te <strong>reflecteren over de kwaliteit van een uitgevoerde taak, zeker wanneer de criteria voor een goede uitvoering duidelijk werden meegedeeld. </strong>
      </p>

      <p class="lead-text">
        Geef je de leerlingen vaak de kans om zelf tot inzicht te komen?
      </p>
      <ul>
        <li>Je kan proberen de leerlingen te stimuleren om zelf werkpunten en sterke punten naar voren te schuiven.</li>
        <li>Je kan de leerlingen eerst zelf aan het woord laten voordat je jouw persoonlijke mening naar voren schuift.</li>
        <li>Probeer specifieke instructies en aandachtspunten mee te geven, dit vergroot de kans op zelfinzicht bij de leerlingen.</li>
      </ul>
    
    </div>`
  },
  analyseInfoBlock3: {
    id: 'analise.info.block3',
    defaultMessage: `<div class="info-block">
      <p>Als je als leerkracht <strong>structurerend</strong> te werk gaat, dan breng je <strong>duidelijkheid</strong>.</p>
      <p>
        Je kunt dat doen door je verwachtingen duidelijk te maken en overzicht te bieden.
      </p>

      <ol>
        <li>
          <h4 class="list-title">
            HELDERE VERWACHTINGEN COMMUNICEREN
          </h4>
          <p class="lead-text">
            Hoe vaak communiceer je sporttechnische en –tactische verwachtingen?
          </p>
          <p class="lead-text">
            Hoe vaak communiceer je gedragsnormen en –regels?
          </p>
          <p class="lead-text">
            Zijn de verwachtingen die je communiceert heel concreet?
          </p>
          <p class="lead-text">
            Probeer je vaak de verwachtingen op lange termijn op te splitsen in tussendoelen?
          </p>
          <ul>
            <li>
              Je kan proberen zowel <strong>sportieve verwachtingen</strong> <span class="green">(‘De bedoeling is dat jullie aan het einde van de les de bal naar elkaar kunnen toetsen met een tussentoets.’)</span> als <strong>gedragsregels en –normen</strong> <span class="green">(‘We proberen de ballen stil te houden tijdens de instructie.’)</span>  duidelijk te maken.
            </li>
            <li>
              Je kan ervoor zorgen dat je zowel de verwachtingen op <strong>korte</strong> als op <strong>lange termijn</strong> duidelijk maakt.
            </li>
            <li>
              Je probeert best om de verwachtingen <strong>concreet</strong> te formuleren <span class="green">(‘De bedoeling is dat je de bal aanspeelt op het moment dat...’)</span>.
            </li>
            <li>
              Wanneer je merkt dat de leerlingen het moeilijk hebben kan je <strong>tussenstappen of tussendoelen communiceren</strong>. Lerares Sofie merkt dat het voor Emiel niet lukt om de bal op te slaan van achter de achterlijn. <span class="green">De leerkracht zegt tegen Emiel dat hij kan proberen om aan het einde van de les de bal over het net te krijgen van achter de driemeterlijn.</span>
            </li>
          </ul>
        </li>
        
        <li>
          <h4 class="list-title">
            OVERZICHT WEERGEVEN
          </h4>
          <p class="lead-text">
            Geef je vaak een duidelijke indeling van de les aan de leerlingen?
          </p>
          <p class="lead-text">
            Kader je de les voldoende in de planning voor de komende lesperiode?
          </p>
          <ul>
            <li>
              Je kan proberen om <strong>vooruit te blikken</strong> met de leerlingen op de komende les of lesperiode waarbij je een duidelijke indeling van de les en een concrete planning voor de komende lesperiode communiceert.
            </li>
          </ul>
        </li>
      </ol>
    </div>`
  },
  analyseInfoBlock4: {
    id: 'analise.info.block4',
    defaultMessage: `<div class="info-block">
      <p>Als structurerende leerkracht maak je niet alleen je verwachtingen duidelijk, je bewaakt ze ook consequent. Bij het opvolgen van het ontwikkelingsproces van je leerlingen is het belangrijk om ook een <strong>procesfocus</strong> te hanteren. Je gaat bijvoorbeeld na of je leerlingen goed op weg zijn naar de vooropgestelde doelen <span class="green">(‘Doen ze de nodige moeite om de looplijnen te volgen?’)</span>. Door je aandacht voor hun vorderingen krijgen leerlingen het gevoel dat je oprecht betrokken bent bij hun ontwikkeling.</p>

      <p class="lead-text">
        Ga je vaak na of de leerlingen de vooropgestelde doelen bereiken en regels naleven?
      </p>
      <p class="lead-text">
        Pas je de vooropgestelde doelen aan als je merkt dat de leerlingen de doelen maar moeilijk bereiken, of geef je extra begeleiding aan leerlingen die het lastig hebben?
      </p>
    <ul>
      <li>
          Je kan proberen <strong>na te gaan</strong> of de leerlingen goed op weg zijn naar de vooropgestelde doelen.<br/>
          <em>Tip</em>: wanneer je gebruik maakt van tussendoelen zal dit eenvoudiger zijn.
      </li>
      <li>
          Je kan de vooropgestelde doelen <strong>bijstellen</strong> wanneer je merkt dat de doelen te makkelijk of te moeilijk zijn. zodanig dat ze uitdagend maar haalbaar zijn voor elke leerling.<br/>
          <em>Tip</em>: Maak op voorhand duidelijk aan de leerlingen dat doelen soms bijgesteld dienen te worden aangezien iedereen een ander ontwikkelingsritme heeft.
      </li>
      <li>
        Probeer ook na te gaan of de leerlingen de verwachtingen wat gedrag betreft respecteren <span class="green">(de leerkracht en de leerlingen hebben de afspraak gemaakt dat het stil moet zijn in de kleedkamer)</span>. Wanneer je merkt dat dit niet lukt kan je proberen om in <strong>dialoog</strong> met de leerlingen te gaan en probeer je hun zelfinzicht aan te spreken.
      </li>
    </ul>
    </div>`
  },
  analyseInfoBlock5: {
    id: 'analise.info.block5',
    defaultMessage: `<div class="info-block">
      <p>Als je als leerkracht autonomieondersteunend te werk gaat, dan wakker je het spelplezier in je leerlingen aan. Je probeert de inhoud van je les af te stemmen op <strong>de interesses</strong> van je leerlingen of probeert hun <strong>nieuwsgierigheid</strong> te ontlokken.</p>
      <p class="flex flex-align-center flex-justify-space-around"><img class="full" src="/assets/images/graphs/spelplezier.png"></p>
      <p>Er zijn drie strategieën die het spelplezier kunnen voeden.</p>
      <ol>
        <li>
          <h4 class="list-title">Spelvormen en uitdaging aanbieden</h4>
          <p class="lead-text">Hoe vaak bied je spelvormen aan om technische en tactische vaardigheden in te oefenen?</p>
          <p class="lead-text">Zorg je ervoor dat de spelvormen die je gebruikt in jouw les voldoende gestructureerd zijn?</p>
          <ul>
            <li>Leraar Bob wil in de les volleybal de opslag inoefenen. <span class="green">Hij maakt gebruik van lege flessen als mikpunt tijdens een specifieke oefening op de opslag. De klas wordt in twee groepen verdeeld en het doel is om als eerste alle flessen van de andere groep omver te serveren.</span></li>
            <li>Je kan proberen om een monotone oefeningen aantrekkelijk te maken door er <strong>uitdaging</strong> in te steken. <span class="green">Zo kan je tijdens een looptraining de leerlingen domino steentjes of puzzel stukjes laten verzamelen; de leerlingen worden tijdens de oefening uitgedaagd om een zo lang mogelijk parcours met dominoblokjes te maken, of om de puzzel te vervolledigen.</span></li>
          </ul>
        </li>
        <li>
          <h4 class="list-title">Fun-elementen integreren</h4>
          <p class="lead-text">Voorzie je in jouw les soms fun-elementen om het spelplezier te voeden?</p>
          <ul>
            <li>Lerares Sara wil de opwarming van basketbal leuker maken voor de leerlingen. <span class="green">Ze vraagt aan de leerlingen om een krant voor hun buik te houden tijdens het dribbelen en ervoor te zorgen dat deze krant niet op de grond valt.</span></li>
          </ul>
        </li>
        <li>
          <h4 class="list-title">Nieuwsgierigheid uitlokken</h4>
          <p class="lead-text">Lok jij vaak de nieuwsgierigheid van de leerlingen uit zodat hun interesse voor een oefening zou vergroten?</p>
          <ul>
            <li>Leraar Tom wil de leerlingen warm maken om actief op te warmen voor kogelstoten. <span class="green">Hij laat de leerlingen mikken op kegels. Onder de kegels zitten grappige ‘wist-je-datjes’ over de leerkracht verstopt.</span></li>
          </ul>
        </li>
      </ol>
    </div>
    `
  },
  analyseInfoBlock6: {
    id: 'analise.info.block6',
    defaultMessage: `<div class="info-block">
      <p>Als leerkrachten autonomieondersteunend zijn, dan hoeven ze niet over alles inbreng toe te staan. Dat is praktisch gezien niet haalbaar en niet wenselijk. Als autonomieondersteunende leerkracht beschik je immers ook over een doelgerichte planning (cfr. leerplan) met <strong>duidelijke verwachtingen</strong> voor je leerlingen en hanteer je ook <strong>regels</strong>. Wanneer inbreng niet mogelijk of wenselijk is, weten autonomieondersteunende leerkrachten de opgelegde taken en regels toch goed te onderbouwen. Ze geven een <strong>betekenisvolle uitleg</strong> waarin leerlingen zich kunnen herkennen omdat die is afgestemd op hun beleving.</p>
      <p class="lead-text">Geef je vaak een betekenisvolle uitleg die de regels en jouw verwachtingen ten opzichte van de leerlingen ondersteunt?</p>
      <ul>
          <li>
            Je kan proberen een zinvolle uitleg te geven waarin de leerlingen zich kunnen <strong>herkennen</strong>, deze uitleg is best afgestemd op hun beleving. Lerares Maaike merkt dat de leerlingen geen zin hebben in de opwarming voor de les handbal. <span class="green">Ze legt uit dat het echt belangrijk is om je degelijk op te warmen vooraleer je gaat sporten aangezien de kans op blessures anders veel groter is</span>.
          </li>
          <li>
            Je kan gebruik maken van <strong>concrete, voorliggende situaties</strong>. Leraar Ferre wil aan zijn leerlingen duidelijk maken dat het belangrijk is om bij molendraai als helper de polsen van de uitvoerder te ondersteunen. <span class="green">Hij vertelt aan de leerlingen dat hij ooit iemand in de les heeft gehad die de polsen niet ondersteunde. De uitvoerder zakte door zijn armen en viel recht op zijn hoofd van de rekstok</span>.
          </li>
          <li>
            Je kan aansluiting zoeken bij de <strong>persoonlijke (intrinsieke) doelen van de leerlingen</strong>. Lerares Julie voorziet een looptraining/evaluatie waarbij de leerlingen zelf verantwoordelijk zijn voor het tellen van hun eigen rondes. <span class="green">Ze legt uit aan de leerlingen dat het tellen op een eerlijke wijze ook een vorm van fair-play is ten opzichte van elkaar</span>.
          </li>
        
      </ul>
    </div>`
  },
  analyseInfoBlock7: {
    id: 'analise.info.block7',
    defaultMessage: `<div class="info-block">
      <p>Autonomieondersteunende leerkrachten maken vaker gebruik van werkwoorden als <strong>‘kunnen’</strong>, <strong>‘voorstellen’</strong> en <strong>‘proberen’</strong> in plaats van <span class="red">‘moeten’, ‘verwachten’ of ‘verplichten’</span>. Je kunt als leerkracht dus op verschillende manieren praten met je leerlingen en dat op verschillende momenten; bijvoorbeeld tijdens het geven van instructies, bij de begeleiding van leerlingen tijdens een oefening, of bij het geven van feedback.</p>
      <p class="flex flex-align-center flex-justify-space-around"><img class="full" src="/assets/images/graphs/uitnodigendcommuniceren.png"></p>
      <p class="lead-text">
        Hoe vaak gebruik je autonomieondersteunende taal in jouw lessen?
      </p>
      <ul>
        <li>
          Lerares Joke spreekt haar leerlingen toe tijdens een spelvorm voetbal. <span class="green">'Het samenspel binnen de teams verliep nog niet zo vlot, ik stel voor dat jullie allemaal zo vaak mogelijk een aanspeelbare positie innemen en je kan proberen om de bal sneller te passen wanneer jullie hier de mogelijkheid voor zien.'</span>
        </li>
      </ul>
    </div>`
  },
  analyseInfoBlock8: {
    id: 'analise.info.block8',
    defaultMessage: `<div class="info-block">
      <p>Het stimuleren van <strong>inbreng</strong> vormt een belangrijke hefboom om de <strong>autonomie</strong> van leerlingen te bevorderen. Als je jouw leerlingen meer inbreng geeft, dan nemen de leerlingen hun eigen leerproces meer in handen en dit bevordert de <strong>autonome motivatie</strong> of plezierbeleving van de leerlingen. </p>
      <p class="flex flex-align-center flex-justify-space-around"><img class="full" src="/assets/images/graphs/inbrengstimuleren.png"></p>
      <p>Er zijn drie strategieën die de inbreng van leerlingen kunnen stimuleren.</p>
      <ol>
        <li>
          <h4 class="list-title">DIALOOG EN INSPRAAK.</h4>
          <p class="lead-text">
            Hoe vaak laat jij ruimte voor dialoog en inspraak?
          </p>
          <p class="lead-text">
            Hoe vaak zijn jouw leerlingen aan het woord?
          </p>
          <p class="lead-text">
            Pols je actief naar hun interesses, wensen en voorkeuren?
          </p>
         
          <ul>
            <li>Lerares Silke laat haar leerlingen aan het woord. <span class="green">Bij het begin van het schooljaar wanneer ze de regels en afspraken vastlegt laat lerares Silke haar leerlingen uitgebreid aan het woord. 'Wat is er volgens jullie nodig om deze lessen leuk en leerrijk  te maken? Wat vinden jullie belangrijk? Welke afspraken zijn noodzakelijk voor een goede samenwerking?'</span></li>
          </ul>
        </li>
        <li>
          <h4 class="list-title">VERANTWOORDELIJKHEID GEVEN</h4>
          <p class="lead-text">Hoe vaak stimuleer je jouw leerlingen om verantwoordelijkheid op te nemen?</p>
          <ul>
            <li>Je kan dit bijvoorbeeld doen door hen zelf een leuke oefening te laten bedenken.</li>
            <li>Je kan leerlingen vragen om elkaar te coachen of feedback te geven zodat ze meer <strong>verantwoordelijkheid</strong> nemen voor hun leerproces. Hierbij is het belangrijk dat ze zich voldoende <strong>competent voelen</strong> om de aan hen toebedeelde verantwoordelijkheid op te nemen.</li>
          </ul>
        </li>
        <li>
          <h4 class="list-title">KEUZE</h4>
          <p>Deze strategie kan in deze tool apart worden geanalyseerd en zal meer diepgaand besproken worden bij de bouwsteen ‘aanbieden van keuze’. </p>
        </li>
      </ol>
    </div>`
  },
  analyseInfoBlock9: {
    id: 'analise.info.block9',
    defaultMessage: `<div class="info-block">
      <p>Keuze is naast dialoog en inspraak, en verantwoordelijkheid geven, een derde belangrijke strategie om de inbreng van leerlingen te vergroten. Als je een keuzemenu aanbiedt, dan kunnen leerlingen naar hun persoonlijke voorkeuren handelen. Hun eigen keuze is in de meeste gevallen immers een weerspiegeling van hun interesse.</p>
      <p class="lead-text">Hoe vaak bied je keuze aan in jouw lessen?</p>
      <p>Als je keuze inbouwt in jouw les werkt dit motiverend, het verhoogt de betrokkenheid van jouw leerlingen. Het aanbieden van keuze hoeft niet moeilijk te zijn zoals blijkt uit volgende <strong>fragmenten</strong> (optiekeuze: wat en actiekeuze: hoe).</p>
      <p class="flex flex-align-center flex-justify-space-around"><img class="half" src="/assets/images/graphs/keuzeaanbieden01.png"><img class="half" src="/assets/images/graphs/keuzeaanbieden02.png"></p>
    </div>`
  },
  defaultAnnotation1: {
    id: 'default.annotation1',
    defaultMessage: 'Annotatie 1'
  },
  defaultAnnotation1Label: {
    id: 'default.annotation1.label',
    defaultMessage: 'Annotatie 1'
  },
  defaultAnnotation2: {
    id: 'default.annotation2',
    defaultMessage: 'Annotatie 2'
  },
  defaultAnnotation2Label: {
    id: 'default.annotation2.label',
    defaultMessage: 'Annotatie 2'
  },
  defaultAnnotation3: {
    id: 'default.annotation3',
    defaultMessage: 'Annotatie 3'
  },
  defaultAnnotation3Label: {
    id: 'default.annotation3.label',
    defaultMessage: 'Annotatie 3'
  },
  defaultAnnotation4: {
    id: 'default.annotation4',
    defaultMessage: 'Annotatie 4'
  },
  defaultAnnotation4Label: {
    id: 'default.annotation4.label',
    defaultMessage: 'Annotatie 4'
  },
  defaultAnnotation5: {
    id: 'default.annotation5',
    defaultMessage: 'Annotatie 5'
  },
  defaultAnnotation5Label: {
    id: 'default.annotation5.label',
    defaultMessage: 'Annotatie 5'
  },
  defaultAnnotation6: {
    id: 'default.annotation6',
    defaultMessage: 'Annotatie 6'
  },
  defaultAnnotation6Label: {
    id: 'default.annotation6.label',
    defaultMessage: 'Annotatie 6'
  }
});



// WEBPACK FOOTER //
// ./src/containers/analyse/messages.js